const SCALES = [
  {
    name: 'xs',
    fullname: 'extra small',
    breakpoint: 600
  },
  {
    name: 'sm',
    fullname: 'small',
    breakpoint: 1024
  },
  {
    name: 'md',
    fullname: 'medium',
    breakpoint: 1440
  },
  {
    name: 'lg',
    fullname: 'large',
    breakpoint: 1920
  },
  {
    name: 'xl',
    fullname: 'extra large',
    breakpoint: Infinity
  }
]

export default {
  namespaced: true,
  state: {
    width: 0,
    height: 0,
    scale: SCALES[0],
    forceEmbed: false
  },
  getters: {
    size: () => () => {
      return {
        width: window.innerWidth || document.documentElement.clientWidth || 0,
        height: window.innerHeight || document.documentElement.clientHeight || 0
      }
    },
    scale: (state, getters) => () => {
      const width = getters.size().width
      for (let i = 0; i < SCALES.length - 1; i++) {
        if (SCALES[i].breakpoint > width) {
          return SCALES[i]
        }
      }

      return SCALES.slice(-1)[0]
    },
    largerThan: (state, getters) => scaleName => {
      const currentScaleName = getters.scale().name
      let required, current
      SCALES.forEach((scale, index) => {
        if (scale.name === currentScaleName) {
          current = index
        }
        if (scale.name === scaleName) {
          required = index
        }
      })

      return current > required
    },
    smallerThan: (state, getters) => scaleName => {
      const currentScaleName = getters.scale().name
      let required, current
      SCALES.forEach((scale, index) => {
        if (scale.name === currentScaleName) {
          current = index
        }
        if (scale.name === scaleName) {
          required = index
        }
      })

      return current < required
    },
    embed: (state) => {
      if (state.forceEmbed) {
        return true
      }
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    }
  },
  mutations: {
    update (state, payload) {
      state.width = payload.width
      state.height = payload.height
      state.scale = {...payload.scale}
    },
    forceEmbed (state) {
      state.forceEmbed = true
    }
  },
  actions: {
    update ({commit, getters}) {
      const size = getters.size()
      const scale = getters.scale()

      commit('update', {...size, scale})
    },
    forceEmbed ({commit}) {
      commit('forceEmbed')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/viewport.js